import React from "react";
import AuthForm from "../components/login/AuthForm";

function Login() {
  return (
    <AuthForm/>
  );
}

export default Login;
